import { Injectable } from '@angular/core';
import { LogLevel } from '../models';
import { LoggingHttpService } from '../services/logging-http.service';
import { ILoggingPublisher } from './logging-publisher.interface';

@Injectable()
export class LoggingApiPublisher implements ILoggingPublisher {
	public constructor(private loggingHttpService: LoggingHttpService) {}

	/* eslint-disable @typescript-eslint/no-unused-vars */
	public async log(title: string, body: string, level: LogLevel): Promise<void> {
		this.loggingHttpService.log(body);
	}
}
